import { request } from "configs/api";
import { SearchQuery, SearchResponse } from "interfaces/common";
import { RevisionDto, SubmitRevisionDto } from "interfaces/revision";

class RevisionService {
  search(query?: SearchQuery): Promise<SearchResponse<RevisionDto>> {
    return request({
      url: "/admin/revisions/list",
      method: "GET",
      params: query || {},
    });
  }

  async create(data: SubmitRevisionDto): Promise<void> {
    await request({
      data,
      url: "/admin/revisions/create",
      method: "POST",
    });
  }

  async getById(id: string): Promise<RevisionDto> {
    return await request({
      url: `/admin/revisions/get/${id}`,
      method: "GET",
    });
  }
}

export const revisionService: RevisionService = new RevisionService();
